module.exports = __webpack_public_path__ + "static/img/img_design.064d98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_design.png
// module id = u3l+
// module chunks = 57